<div class="release-card release-card--${view}">
  <div class="release-card__body">
    <img if.bind="release.imageUrl" src.bind="release.imageUrl" class="release-thumb" click.trigger="handleImageClick()" alt="${release.brand}" />
    <div class="release-card__content">
      <div class="release-card__header">
        <div class="release-card__info">
          <a if.bind="release.sourceUrl" href.bind="release.sourceUrl" target="_blank" class="release-source release-source--link">${release.source} <span class="icon icon--external" aria-hidden="true"></span></a>
          <div else class="release-source">${release.source}</div>
          <div class="release-brand">${release.brand}</div>
          <div class="release-line">${release.toyLine}</div>
          <div if.bind="release.note" class="release-note">${release.note}</div>
          <div if.bind="release.price" class="release-price">${release.price}</div>
        </div>
        <div class="release-card__meta">
          <div if.bind="isUpcoming" class="release-time"><span class="release-time__icon icon icon--clock" aria-hidden="true"></span><span class="release-time__text">${release.localTime}</span></div>
          <button
            if.bind="canSubscribe"
            type="button"
            class="release-card__bell ${isSubscribed ? 'is-active' : ''}"
            click.trigger="handleBellClick()"
            disabled.bind="subscriptionPending"
            title.bind="bellTitle"
            aria-label="Toggle availability alert for this release"
            aria-pressed.bind="isSubscribed"><span class="icon ${isSubscribed ? 'icon--bell-filled' : 'icon--bell'}" aria-hidden="true"></span></button>
        </div>
      </div>
    </div>
  </div>
</div>
